<div
  class="lui-card-ripple"
  matRipple
  *ngIf="stretchedLinkEl"
  [matRippleTrigger]="stretchedLinkEl.nativeElement"
></div>
<div class="lui-card-main">
  <ng-content select="[luiCardActions]"></ng-content>
  <ng-content select="[luiCardBadge]"></ng-content>
  <ng-content select="[luiCardMain]"></ng-content>
  <div luiCardMain *ngIf="!_content">
    <ng-content></ng-content>
  </div>
</div>
<ng-content select="lui-card-footer"></ng-content>
